import { useRef, type ReactNode } from "react";
import classNames from "classnames";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import {
    isOverflowingX,
    useTruncationTooltip,
} from "@design-system/Tooltip/useTruncationTooltip";
import { getNodeText } from "./boardCardText";
import styles from "./BoardTruncatedText.module.scss";

/**
 * Board text on one line (column and lane titles, card context lines), all
 * of it as plain text in a tooltip only while it's cut off.
 */
export const BoardTruncatedText = ({
    className,
    children,
}: {
    className?: string;
    children: ReactNode;
}) => {
    const ref = useRef<HTMLSpanElement>(null);
    const truncationTooltipProps = useTruncationTooltip({
        ref,
        isTruncated: isOverflowingX,
    });
    return (
        <Tooltip content={getNodeText(children)} {...truncationTooltipProps}>
            <span ref={ref} className={classNames(styles.text, className)}>
                {children}
            </span>
        </Tooltip>
    );
};
